module.exports = __webpack_public_path__ + "assets/img/home_b1.d3b760c7.png";